import SchoolIcon from "@mui/icons-material/School";
import { GraduationServicePath, INTERNSHIP_SESSIONS } from "utils/constants";
import permissions from "app/permissions";
import ListInternshipSessions from "./List";
import CreateInternshipSessions from "./Create";
import EditInternshipSessions from "./Edit";
import ShowInternshipSessions from "./Show";

export const resources = {
  isMenu: true,
  icon: <SchoolIcon />,
  name: GraduationServicePath + INTERNSHIP_SESSIONS,
  title: "Стажантски сесии",
  list: <ListInternshipSessions />,
  create: <CreateInternshipSessions />,
  edit: <EditInternshipSessions />,
  show: <ShowInternshipSessions />,
  permission: permissions.canPreviewInternshipSessions,
};
